import React, { SVGAttributes, useState } from "react";

interface Props extends SVGAttributes<SVGElement> {}

const IconLineSegment: React.FC<React.PropsWithChildren<Props>> = (props) => {
  return (
    <div
      style={{
        width: "16px",
        height: "16px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <svg viewBox="0 0 16 16" width="14">
        <circle cx="8" cy="8" r="5" />
      </svg>
    </div>
  );
};

export default IconLineSegment;
